import { Navigate, useRoutes } from "react-router-dom";
import SignupPage from "./pages/SignupPage";
import YourDetails from "./pages/YourDetailsPage";
import ConfirmEmailOtpPage from "./pages/ConfirmEmailOtp";
import PanVerificationPage from "./pages/PanVerificationPage";
import AadhaarKYCPage from "./pages/AadharKYCPage";
import YourProfilePage from "./pages/YourProfilePage";
import LinkUsingIFSC from "./pages/LinkUsingIFSC";
import UploadDocumentsPage from "./pages/UploadDocumentsPage";
import NomineesPage from "./pages/NomineePage";
import EsignPage from "./pages/EsignPage";
import CongratulationsPage from "./pages/CongratulationsPage";
import CameraModule from "./Components/CameraModule/CameraModule";
import WebcamDemo from "./Components/CameraModule/WebCamFaceDetection";
import TradingPreference from "./pages/TradingPreference";
import { useLocation } from "react-router-dom";
import { useDispatch } from "react-redux";
import { setPathName } from "./Components/redux/actions/pathNameActions";
import { useEffect } from "react";
import CompletedPage from "./pages/CompletedPage";
import PageNotFound from "./pages/PageNotFound";
import CountrySelector from "./Components/CountryCheck";
import AccountType from "./pages/AccountType";
import FATCA from "./pages/FATCA";
import OverseasAddress from "./pages/OverseasAddress";
import OverseasAddressOutsideIndia from "./pages/OverseasAddressOutsideIndia";
import PISBankAccount from "./pages/PISBankAccount";
import PdfForm from "./pages/PDFAnnotationsTesting";
import LandingPage from "./pages/LandingPage/LandingPage1/LandingPage1";
import PassportDetails from "./pages/PassportDetails";

export default function Router() {
  const pathName = useLocation().pathname;
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(setPathName(pathName));
  }, [pathName]);

  const routes = useRoutes([
    {
      path: "",
      element: <LandingPage />,
    },
    {
      path: "email",
      element: <YourDetails />,
    },

    {
      path: "PdfForm",
      element: <PdfForm />,
    },
    {
      path: "account_type",
      element: <AccountType />,
    },
    {
      path: "mobile",
      element: <SignupPage />,
    },
    {
      path: "confirmemailotp",
      element: <ConfirmEmailOtpPage />,
    },

    {
      path: "panverification",
      element: <PanVerificationPage />,
    },
    {
      path: "kra",
      element: <AadhaarKYCPage />,
    },
    {
      path: "tradingPreference",
      element: <TradingPreference />,
    },
    {
      path: "yourprofile",
      element: <YourProfilePage />,
    },
    {
      path: "passport",
      element: <PassportDetails />,
    },
    // {
    //   path: "overseasAddress",
    //   element: <OverseasAddressOutsideIndia />,
    // },
    {
      path: "addressDetails",
      element: <OverseasAddress />,
    },
    {
      path: "fatca",
      element: <FATCA />,
    },
    {
      path: "bankDetails",
      element: <LinkUsingIFSC />,
    },
    {
      path: "pisBank",
      element: <PISBankAccount />,
    },
    {
      path: "ipv",
      element: <WebcamDemo />,
    },

    {
      path: "uploaddocuments",
      element: <UploadDocumentsPage />,
    },
    {
      path: "nominee",
      // element: <NewNominee />
      element: <NomineesPage />,
    },

    {
      path: "formPreview",
      element: <EsignPage />,
    },

    {
      path: "/*",
      element: <PageNotFound />,
    },

    {
      path: "congratulations",
      element: <CongratulationsPage />,
    },
    {
      path: "CountrySelector",
      element: <CountrySelector />,
    },
    {
      path: "completed",
      element: <CompletedPage />,
    },
  ]);

  return routes;
}
